"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignPublishUtils = exports.CohortRules = exports.V2 = exports.Recipient = exports.Offer = exports.ExtraData = exports.CampaignBatching = exports.Campaign = exports.ListCountType = exports.WithClassName = exports.Operator = exports.FieldCondition = exports.ListCondition = exports.Condition = exports.JoinType = exports.JoinCondition = exports.Rule = void 0;
const campaign_1 = require("./campaign");
Object.defineProperty(exports, "Campaign", { enumerable: true, get: function () { return campaign_1.Campaign; } });
const campaign_batching_1 = require("./campaign-batching");
Object.defineProperty(exports, "CampaignBatching", { enumerable: true, get: function () { return campaign_batching_1.CampaignBatching; } });
const V2 = __importStar(require("./casa-rules-v2"));
exports.V2 = V2;
const CohortRules = __importStar(require("./cohort-rule"));
exports.CohortRules = CohortRules;
const condition_1 = require("./condition");
Object.defineProperty(exports, "Condition", { enumerable: true, get: function () { return condition_1.Condition; } });
const extra_data_1 = require("./extra-data");
Object.defineProperty(exports, "ExtraData", { enumerable: true, get: function () { return extra_data_1.ExtraData; } });
const field_condition_1 = require("./field-condition");
Object.defineProperty(exports, "FieldCondition", { enumerable: true, get: function () { return field_condition_1.FieldCondition; } });
const join_condition_1 = require("./join-condition");
Object.defineProperty(exports, "JoinCondition", { enumerable: true, get: function () { return join_condition_1.JoinCondition; } });
const join_type_1 = require("./join-type");
Object.defineProperty(exports, "JoinType", { enumerable: true, get: function () { return join_type_1.JoinType; } });
const list_condition_1 = require("./list-condition");
Object.defineProperty(exports, "ListCondition", { enumerable: true, get: function () { return list_condition_1.ListCondition; } });
const list_count_type_1 = require("./list-count-type");
Object.defineProperty(exports, "ListCountType", { enumerable: true, get: function () { return list_count_type_1.ListCountType; } });
const offer_1 = require("./offer");
Object.defineProperty(exports, "Offer", { enumerable: true, get: function () { return offer_1.Offer; } });
const operator_1 = require("./operator");
Object.defineProperty(exports, "Operator", { enumerable: true, get: function () { return operator_1.Operator; } });
const publish_format_1 = require("./publish-format");
Object.defineProperty(exports, "CampaignPublishUtils", { enumerable: true, get: function () { return publish_format_1.CampaignPublishUtils; } });
const recipient_1 = require("./recipient");
Object.defineProperty(exports, "Recipient", { enumerable: true, get: function () { return recipient_1.Recipient; } });
const rule_1 = require("./rule");
Object.defineProperty(exports, "Rule", { enumerable: true, get: function () { return rule_1.Rule; } });
const with_class_name_1 = require("./with-class-name");
Object.defineProperty(exports, "WithClassName", { enumerable: true, get: function () { return with_class_name_1.WithClassName; } });
// const rules: CohortRules.CohortRules = {
//   cohortRules: [
//     {
//       name: [
//         {
//           entity: 'tier',
//           listConditionType: null,
//           negate: false,
//           operation: CohortRules.OperationType.STRING_MATCHES,
//           value: 'KPS',
//         },
//       ],
//       tier: [
//         {
//           entity: 'tier',
//           listConditionType: null,
//           negate: false,
//           operation: CohortRules.OperationType.STRING_MATCHES,
//           value: 'KPS',
//         },
//       ],
//     },
//     {
//       storeName: [
//         {
//           entity: 'bill',
//           listConditionType: null,
//           negate: false,
//           operation: CohortRules.OperationType.STRING_MATCHES,
//           value: 'KPS',
//         },
//       ],
//     },
//   ],
// };
// const rules3: CohortRules.CohortRules = {
//   cohortRules: [
//     {
//       division: [
//         {
//           entity: "product",
//           listConditionType: null,
//           value: "men",
//           operation: CohortRules.OperationType.STRING_MATCHES,
//           negate: false,
//         },
//       ],
//     },
//     {
//       atv: [
//         {
//           entity: "user",
//           listConditionType: null,
//           value: "100-1000",
//           operation: CohortRules.OperationType.NUM_BETWEEN,
//           negate: false,
//         },
//       ],
//     },
//   ],
// };
// const rule = new CohortRules.CohortCasaRuleTransformer(
//   rules,
//   batchRuleSource
// ).getCasaRule();
// console.log(JSON.stringify(rule, null, 2));



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/index.js
// module id = 1211
// module chunks = 0